export default __webpack_public_path__ + "static/media/logo-instagram.169e7476.svg";